import $ from 'jquery'
import store_assurance from '@/store/mods/parametres/assurance'

export default {
    name: 'manage-assur-societe',
    components: {},
    props: {
        liste_assur_souscripteurs: {
            type: Array,
            default: () => []
        },
        action_data_type: String,
        action_toggler: Number,
        societe_action_toggler: Number,
        selected_societe: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            prix_unitaire_forfait: "",
            qte_forfait: "",
            duree_forfait: "",
            num_bon_is_required: 1,
            checked_assurances: [],
            checked_societes: [],
            all_checked: false,
            save_loading: false,
            msg_err: '',
            liste_assurances: [],
            selected_assurance: {},
            modal_title: '',
            is_config_montant: false,
            can_check_societe: true,
            info_societe: {
                prefixe: '',
                prix_unitaire_forfait: '',
                qte_forfait: '',
                duree_forfait: '',
                num_bon_is_required: 1
            }
        }
    },

    watch: {
        action_toggler() {
            this.setListeAssurances()

            this.prix_unitaire_forfait = ''
            this.duree_forfait = ''
            this.checked_societes = []
            this.checked_assurances = []
            this.all_checked = false
            if (this.action_data_type == 'model_forfait') {
                this.is_config_montant = false
                this.modal_title = 'Gérer les sociétés forfaitaires'
                this.setSocietesForfaitaires()
            } else {
                this.is_config_montant = true
                this.modal_title = 'Configurer Montant forfaitaire'
            }
        },

        societe_action_toggler() {
            let num_bon_is_required = 0
            if (this.selected_societe.num_bon_is_required === null) {
                console.log("is NULL");
                
                num_bon_is_required = 1
            } else {
                num_bon_is_required = this.selected_societe.num_bon_is_required
            }
            this.info_societe = {
                prefixe: this.selected_societe.prefixe_reference_facture,
                prix_unitaire_forfait: this.selected_societe.prix_unitaire_forfait,
                qte_forfait: this.selected_societe.qte_forfait,
                duree_forfait: this.selected_societe.duree_forfait,
                num_bon_is_required: num_bon_is_required
            }
        },

        selected_assurance() {
            if (this.selected_assurance.id == 0) {
                $('.fassur').fadeIn(200)
            } else {
                this.showHideAsssurances()
            }
        }
    },
    
    computed: {

    },

    mounted() {

    },

    methods: {
        showHideAsssurances() {
            $('.fassur').fadeOut(200)

            setTimeout(() => {
                $('.fassur-'+this.selected_assurance.id).fadeIn(100)
            }, 300);
        },

        setListeAssurances() {
            this.liste_assurances = []
            let tmp_assur = {
                id: 0,
                libelle: "Toutes les assurances"
            }
            this.selected_assurance = tmp_assur
            this.liste_assurances.push(tmp_assur)

            this.liste_assur_souscripteurs.forEach(el => {
                let tmp_assur = {
                    id: el.assurance_id,
                    libelle: el.raison_sociale
                }
                this.liste_assurances.push(tmp_assur)
            });
        },

        setSocietesForfaitaires() {
            this.liste_assur_souscripteurs.forEach((assurance) => {
                assurance.souscripteurs.forEach((_data) => {
                    if (_data.a_model_forfait == 1) {
                        this.checked_societes.push(_data.souscripteur_id)
                    }
                })
            });
        },

        toutSelectionner() {
            let is_checked = $('#all-assur').is(":checked")
            this.toggleAllChecked(is_checked)
        },

        toggleAllChecked(is_checked) {
            this.checked_societes = []
            this.checked_assurances = []
            
            this.liste_assur_souscripteurs.forEach((assurance) => {
                if (is_checked) {
                    this.checked_assurances.push(assurance.assurance_id)
                }

                assurance.souscripteurs.forEach((_data) => {
                    if (is_checked ) {
                        if (this.action_data_type == 'model_forfait') {
                            this.checked_societes.push(_data.souscripteur_id)
                        } else {
                            if (_data.a_model_forfait == 1) {
                                this.checked_societes.push(_data.souscripteur_id)
                            }
                        }
                    }
                })
            });
            
            this.all_checked = is_checked
        },

        touteAssurances(index) {
            let is_checked = $('#f-assur-'+index).is(":checked")

            this.toggleAssuranceChecked(is_checked, index)
        },

        toggleAssuranceChecked(is_checked, index) {
            this.liste_assur_souscripteurs.forEach((assurance) => {
                if (assurance.assurance_id == index) {
                    if (is_checked) {
                        assurance.souscripteurs.forEach((_data) => {
                            let index_of = this.checked_societes.indexOf(_data.souscripteur_id)
                            if (index_of > -1) {
                                this.checked_societes.splice(index_of, 1)
                            }
                        })
                    }

                    assurance.souscripteurs.forEach((_data) => {
                        if (is_checked) {
                            if (this.action_data_type == 'model_forfait') {
                                this.checked_societes.push(_data.souscripteur_id)
                            } else {
                                if (_data.a_model_forfait == 1) {
                                    this.checked_societes.push(_data.souscripteur_id)
                                }
                            }
                            // this.checked_societes.push(_data.souscripteur_id)
                        } else {
                            let index_of = this.checked_societes.indexOf(_data.souscripteur_id)
                            if (index_of > -1) {
                                this.checked_societes.splice(index_of, 1)
                            }
                        }
                    })
                }
            });
            
            this.all_checked = is_checked
        },

        save() {
            if (this.action_data_type == 'model_forfait') {
                this.saveSocieteWithModelForfaitaire()
            } else {
                this.saveMontantForfaitaireSocietes()
            }
        },

        saveSocieteWithModelForfaitaire() {
            const data = {
                souscripteurs: this.checked_societes
            }
            this.save_loading = true
            store_assurance.updateSouscripteursForfaitaires(data).then((response) => {
                if (response.success) {
                    this.$refs.mng_model_forfait.click()
                    this.successToast(response.message)

                    this.$emit("emitRefreshSouscripteurs")
                } else {
                    this.msg_err = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_err = "Une erreur est survenue lors de l'enregistrement. Veuillez réessayer plus tard."
            })
        },

        async saveMontantForfaitaireSocietes() {
            const isValid = await this.$refs.souscripteur_form.validate();
            if (!isValid) {
                return;
            }

            const data = {
                souscripteurs: this.checked_societes,
                prix_unitaire_forfait: parseInt(this.prix_unitaire_forfait),
                qte_forfait: parseInt(this.qte_forfait),
                duree_forfait: parseInt(this.duree_forfait),
                num_bon_is_required: this.num_bon_is_required
            }
            
            this.save_loading = true
            store_assurance.updateMontantForfaitaire(data).then((response) => {
                if (response.success) {
                    this.$refs.mng_model_forfait.click()
                    this.successToast(response.message)
                    this.$refs.souscripteur_form.reset()

                    this.$emit("emitRefreshSouscripteurs")
                } else {
                    this.msg_err = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_err = "Une erreur est survenue lors de l'enregistrement. Veuillez réessayer plus tard."
            })
        },

        async saveInfoSociete() {
            const isValid = await this.$refs.souscripteur_edit_form.validate();
            if (!isValid) {
                return;
            }

            const data = {
                prefixe: this.info_societe.prefixe,
                prix_unitaire_forfait: (this.info_societe.prix_unitaire_forfait != null) ? parseInt(this.info_societe.prix_unitaire_forfait) : '',
                qte_forfait: (this.info_societe.qte_forfait != null) ? parseInt(this.info_societe.qte_forfait) : '',
                duree_forfait: (this.info_societe.duree_forfait != '') ? parseInt(this.info_societe.duree_forfait) : '',
                souscripteur_id: this.selected_societe.souscripteur_id,
                num_bon_is_required: this.info_societe.num_bon_is_required
            }
            
            this.save_loading = true
            store_assurance.updateInfoSociete(data).then((response) => {
                if (response.success) {
                    this.$refs.edt_societe.click()
                    this.successToast(response.message)
                    this.$refs.souscripteur_edit_form.reset()

                    this.$emit("emitRefreshSouscripteurs")
                } else {
                    this.msg_err = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_err = "Une erreur est survenue lors de l'enregistrement. Veuillez réessayer plus tard."
            })
        }
    }
}